import { Link } from 'react-router'
import { AngledBand } from '@carouselgg/nexus/angled-band'
import { DisplayHeading } from '@carouselgg/nexus/display-heading'
import { ScrollReveal } from '@carouselgg/nexus/scroll-reveal'
import { DiscordLogo } from '@carouselgg/nexus/icon'
import { NewsletterForm } from '../components/NewsletterForm'
import { DISCORD_INVITE } from '../constants/links'
import { useTrackVisibility } from '../hooks/useTrackVisibility'
import styles from './CTA.module.css'

export function CTA() {
  const ref = useTrackVisibility<HTMLDivElement>('cta')

  return (
    <AngledBand id="community" tone="base" slice="top">
      <div className={styles.inner} ref={ref}>
        <ScrollReveal>
          <div className={styles.copy}>
            {/* The landing e2e asserts on the literal "Create Your Identity". */}
            <DisplayHeading as="h2" size="7xl">Ready up.</DisplayHeading>
            <p className={styles.lede}>
              Creating an identity is free and takes about two minutes. You will have a Trust Score
              before the next split opens registration.
            </p>
            <div className={styles.ctas}>
              <Link to="/signup" className={styles.primaryCta}>Create Your Identity</Link>
              <a
                href={DISCORD_INVITE}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.discord}
              >
                <DiscordLogo size={17} />
                Join the Discord
              </a>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={90}>
          <div className={styles.newsletter}>
            <span className={styles.newsletterKicker}>Not ready yet</span>
            <p className={styles.newsletterBody}>
              Get an email when leagues open registration in your game and region.
            </p>
            <NewsletterForm />
          </div>
        </ScrollReveal>
      </div>
    </AngledBand>
  )
}
